import { render, staticRenderFns } from "./ConfirmPush.vue?vue&type=template&id=44a82e4f"
import script from "./ConfirmPush.vue?vue&type=script&lang=js"
export * from "./ConfirmPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports